import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root'
})
export class BrowserCompatibilityService {
  static SMALL_SCREEN_THRESHOLD = '80em'

  constructor() {}

  canHover(): boolean {
    return matchMedia('(hover: hover)').matches
  }

  isCoarsePointer(): boolean {
    return matchMedia('(pointer: coarse)').matches
  }

  isFinePointer(): boolean {
    return matchMedia('(pointer: fine)').matches
  }

  hasPointer(): boolean {
    return !matchMedia('(pointer: none)').matches
  }

  isSmallScreen(): boolean {
    return matchMedia(`(max-width: ${BrowserCompatibilityService.SMALL_SCREEN_THRESHOLD})`).matches
  }
}
